import { OBaseModel } from '@olameter/o-utilities';
import { Location } from 'src/app/proto/generated/inv_api_message_pb';

export class LocationModel implements OBaseModel {
  name: string;
  locationName: string;
  isVehicle: boolean;
  contractName?: string;

  static Mapper(source: Location): LocationModel {
    if (!source) {
      return null;
    }

    return {
      name: source.getName(),
      locationName: source.getLocationName(),
      isVehicle: source.getIsVehicle(),
      contractName: source.getContractName(),
    };
  }

  static MapperList(references: Location[]): LocationModel[] {
    const ret: LocationModel[] = [];
    references?.forEach((reference) => {
      ret.push(LocationModel.Mapper(reference));
    });
    return ret;
  }

  static MapperProto(source: LocationModel): Location {
    const destination = new Location();
    if (!source) {
      return destination;
    }

    destination.setName(source.name || '');
    destination.setLocationName(source.locationName || '');
    destination.setIsVehicle(!!source.isVehicle);
    destination.setContractName(source.contractName || '');

    return destination;
  }
}
